import { ArtistReview, ProjectReview } from "../types";

const editReviewPath = (review: ProjectReview | ArtistReview) =>
  `/${review.reviewableType.toLowerCase()}s/${review.reviewableId}/reviews/${
    review.type
  }/edit`;

export { editReviewPath };
